import { app } from '../../../../../app';
import { Controller } from './profile-attributes.controller';

app.component('companyUserDirectoriesManageAccountProfileAttributes', {
    bindings: {
        account: '<',
        accountId: '<',
        companyId: '<',
        profileAttributes: '<',
    },
    controller: Controller,
    templateUrl: require('./profile-attributes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/profile-attributes/profile-attributes.component.js